/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type OpenUseCreditModalActionActionType =
  (typeof OpenUseCreditModalActionActionType)[keyof typeof OpenUseCreditModalActionActionType];

export const OpenUseCreditModalActionActionType = {
  open_use_credits: 'open_use_credits',
} as const;
